import { roles } from "constants/index";

export const rolesNavNoti = [roles.qs, roles.departmentManager, roles.shopManager, roles.regionManager, roles.viceRegionManager]

export const rolesNotNavTimesheet = [roles.qs, roles.regionManager, roles.viceRegionManager, roles.seniorAreaManager, roles.departmentManager, roles.areaManager]

export const rolesNavListEmployee = [roles.admin, roles.shopManager]

export const rolesNavListShop = [roles.admin]

export const rolesNavCertificate = [roles.qs, roles.shopManager]

export const rolesIngredientSushi = [roles.admin]

export const rolesBox = [roles.admin]

export const rolesRevenue = [roles.admin, roles.departmentManager, roles.areaManager, roles.shopManager, roles.regionManager, roles.viceRegionManager]

export const rolesGrowth = [roles.admin, roles.departmentManager, roles.regionManager, roles.viceRegionManager]

export const rolesFetchCountNoti = [roles.shopManager]

export const rolesMap = [roles.admin, roles.regionManager, roles.viceRegionManager, roles.qs, roles.seniorAreaManager]

export const rolesNotInventory = [roles.seniorAreaManager]

export const rolesNotCalculatorSushi = [roles.departmentManager, roles.areaManager, roles.regionManager, roles.viceRegionManager]
